import {createUseStyles} from 'react-jss';

export const useStyles = createUseStyles({
  select2: {
    display: 'inline',
  },
  row: {
    paddingBottom: '10px',
  }
});
